import { render, staticRenderFns } from "./ChevronRightLarge.vue?vue&type=template&id=25360bda&"
import script from "./ChevronRightLarge.vue?vue&type=script&lang=js&"
export * from "./ChevronRightLarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src367672788/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25360bda')) {
      api.createRecord('25360bda', component.options)
    } else {
      api.reload('25360bda', component.options)
    }
    module.hot.accept("./ChevronRightLarge.vue?vue&type=template&id=25360bda&", function () {
      api.rerender('25360bda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/icons/ChevronRightLarge.vue"
export default component.exports